// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --header-height: 55px;
}

.header {
  position: fixed;
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--header-height);
  inset: 0 0 auto;
  color: var(--color-0);
  background-color: var(--bg-color-0);
  box-shadow: var(--box-shadow-0);
  z-index: var(--elevation-app-bar);
  padding-top: env(safe-area-inset-top);
  box-sizing: padding-box;
}

.header > * {
    display: flex;
    align-items: center;
    height: 100%;
  }

.header-center {
    flex-grow: 1;
  }

.header-title {
    padding-left: 8px;
    font-size: 18px;
  }

.header-btn {
    color: white;
    border-radius: 0;
    min-width: 32px;
    width: 32px;
    height: 100%;
    margin-left: 8px;
    padding: 5px 6px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

.header-btn--selected {
      transform: rotateZ(-90deg);
    }

.header-btn > svg {
      width: 14px;
      height: 14px;
    }

.header-nav-btn {
    margin: auto 15px auto 0;
    padding: 18px 15px 19px;
    font-weight: 400;
    font-size: 14;
    color: black;
    text-decoration: none;
  }

.header-nav-btn--selected {
      padding: 18px 15px 14px;
      font-size: 14;
      border-bottom: 5px solid #24b248;
      border-radius: 0;
    }

.header-nav-btn-dark {
      color: white;
    }

.header-nav-btn-notification-indicator {
      height: 12px;
      width: 12px;
      color: var(--color-red-3);
      margin-right: 3px;
    }

.header__env-text {
    margin: 75px;
    font-size: 1.1rem;
    font-weight: 600;
  }

.header--local-env {
    background-color: var(--color-green-2);
  }

.header--test-env {
    background-color: var(--color-green-2);
  }

.header--stage-env {
    background-color: #ffeeba;
  }

.logo-wrapper {
  padding: 10px;
  margin-left: 10px;
  margin-right: 60px;
}

.logo-wrapper > svg {
    width: 30px;
  }

.logo-wrapper > svg * {
      fill: currentcolor;
    }

.header-buffer {
  position: relative;
  height: var(--header-height);
  width: 100%;
}

@supports (height: env(safe-area-inset-top)) {

.header-buffer {
    min-height: calc(env(safe-area-inset-top) + var(--header-height))
}
  }
`, "",{"version":3,"sources":["webpack://./app/components/Header/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;EAC/B,iCAAiC;EACjC,qCAAqC;EACrC,uBAAuB;AAiFzB;;AA/EE;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;AAEA;IACE,YAAY;EACd;;AAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;AAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,qDAAqD;EAUvD;;AARE;MACE,0BAA0B;IAC5B;;AAEA;MACE,WAAW;MACX,YAAY;IACd;;AAGF;IACE,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,qBAAqB;EAmBvB;;AAjBE;MACE,uBAAuB;MACvB,aAAa;MACb,gCAAgC;MAChC,gBAAgB;IAClB;;AAEA;MACE,YAAY;IACd;;AAEA;MACE,YAAY;MACZ,WAAW;MACX,yBAAyB;MACzB,iBAAiB;IACnB;;AAGF;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;AAEA;IACE,sCAAsC;EACxC;;AAEA;IACE,sCAAsC;EACxC;;AAEA;IACE,yBAAyB;EAC3B;;AAGF;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AASpB;;AAPE;IACE,WAAW;EAKb;;AAHE;MACE,kBAAkB;IACpB;;AAIJ;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;AAKb;;AAHE;;AALF;IAMI;AAEJ;EADE","sourcesContent":[":root {\n  --header-height: 55px;\n}\n\n.header {\n  position: fixed;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: var(--header-height);\n  inset: 0 0 auto;\n  color: var(--color-0);\n  background-color: var(--bg-color-0);\n  box-shadow: var(--box-shadow-0);\n  z-index: var(--elevation-app-bar);\n  padding-top: env(safe-area-inset-top);\n  box-sizing: padding-box;\n\n  & > * {\n    display: flex;\n    align-items: center;\n    height: 100%;\n  }\n\n  &-center {\n    flex-grow: 1;\n  }\n\n  &-title {\n    padding-left: 8px;\n    font-size: 18px;\n  }\n\n  &-btn {\n    color: white;\n    border-radius: 0;\n    min-width: 32px;\n    width: 32px;\n    height: 100%;\n    margin-left: 8px;\n    padding: 5px 6px;\n    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n\n    &--selected {\n      transform: rotateZ(-90deg);\n    }\n\n    & > svg {\n      width: 14px;\n      height: 14px;\n    }\n  }\n\n  &-nav-btn {\n    margin: auto 15px auto 0;\n    padding: 18px 15px 19px;\n    font-weight: 400;\n    font-size: 14;\n    color: black;\n    text-decoration: none;\n\n    &--selected {\n      padding: 18px 15px 14px;\n      font-size: 14;\n      border-bottom: 5px solid #24b248;\n      border-radius: 0;\n    }\n\n    &-dark {\n      color: white;\n    }\n\n    &-notification-indicator {\n      height: 12px;\n      width: 12px;\n      color: var(--color-red-3);\n      margin-right: 3px;\n    }\n  }\n\n  &__env-text {\n    margin: 75px;\n    font-size: 1.1rem;\n    font-weight: 600;\n  }\n\n  &--local-env {\n    background-color: var(--color-green-2);\n  }\n\n  &--test-env {\n    background-color: var(--color-green-2);\n  }\n\n  &--stage-env {\n    background-color: #ffeeba;\n  }\n}\n\n.logo-wrapper {\n  padding: 10px;\n  margin-left: 10px;\n  margin-right: 60px;\n\n  & > svg {\n    width: 30px;\n\n    & * {\n      fill: currentcolor;\n    }\n  }\n}\n\n.header-buffer {\n  position: relative;\n  height: var(--header-height);\n  width: 100%;\n\n  @supports (height: env(safe-area-inset-top)) {\n    min-height: calc(env(safe-area-inset-top) + var(--header-height));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
